import React, { useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import MovieCard from './MovieCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MovieCarousel = ({ movies, autoplayDelay = 5000 }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true,
      align: 'start',
      skipSnaps: false,
      dragFree: true,
    },
    [Autoplay({ delay: autoplayDelay, stopOnInteraction: false })]
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
  }, [emblaApi]);

  return (
    <div className="relative">
      {/* Carousel Container */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-6">
          {movies.map((movie) => (
            <div 
              key={movie._id || movie.id} 
              className="flex-[0_0_100%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33.333%] lg:flex-[0_0_25%]"
            >
              <MovieCard movie={movie} />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons - Hidden on Mobile, Visible on Desktop */}
      <button
        onClick={scrollPrev}
        className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-[#FDB714] hover:bg-[#e5a510] p-3 rounded-full transition-colors z-10 shadow-lg items-center justify-center"
        aria-label="Previous"
      >
        <ChevronLeft className="text-black" size={24} />
      </button>
      <button
        onClick={scrollNext}
        className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-[#FDB714] hover:bg-[#e5a510] p-3 rounded-full transition-colors z-10 shadow-lg items-center justify-center"
        aria-label="Next"
      >
        <ChevronRight className="text-black" size={24} />
      </button>

      {/* Swipe Indicator for Mobile */}
      <div className="md:hidden text-center mt-4">
        <p className="text-gray-500 text-xs">← Kaydır →</p>
      </div>
    </div>
  );
};

export default MovieCarousel;
